import { FC, PropsWithChildren } from 'react';
import { CatLayoutContainer } from '@blocks-react/components/LayoutContainer';

export const SubheaderRow: FC<PropsWithChildren> = ({ children }) => (
  <CatLayoutContainer>
    <div className="d-flex align-items-center">{children}</div>
  </CatLayoutContainer>
);
